// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

// This is a temporary store while we are transitioning from Flux to Redux. This file exports
// the configured Redux store for use by actions and selectors.

//console.log('wa/stores/redux_store.jsx, top')
//this runs before an redux_store.jsx console.log()
import configureStore from 'store';

//so this will take some important actions, see webapp/store/index.js, exported function configureStore()
const store = configureStore();

export function bindActionToRedux(action, ...args) {
    return async () => {
        await action(...args)(store.dispatch, store.getState);
    };
}

if (process.env.NODE_ENV !== 'production') { //eslint-disable-line no-process-env
    window.store = store;
}
//for prototype need this to dispatch SET_DEMO_VMCRCR from console, turn off when done with prototype
//DONOT disable this console.log without disabling windows.store
//console.log("wa/stores/redux_store.jsx, when done prototype, remember to remove window.store")
//window.store = store;

export default store;
